import React, { useState } from "react";
import {
  WarningFilled,
  MoreOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
const AIRemarks = ({ aiRemarks, docType }) => {
  const [open, setOpen] = useState(false);
  let status = null;

  const filterRemarks = aiRemarks?.filter(
    (ele) => ele?.documentType === docType && ele?.documentStatus,
  );

  if (filterRemarks?.length !== 0) {
    status = filterRemarks?.every((ele) => { 
      const response = ele?.OCRData?.response;
      if (response && typeof response === "object" &&"error" in ele?.OCRData?.response) {
        if (ele?.OCRData?.response?.error) return false;
      }
      return true;
    });
  }

  const message = filterRemarks?.map((ele) => {
    const data = ele?.OCRData?.response?.error;
    if (data) {
      return <li>{data}</li>;
    }
  });

  const bgColor =
    status === null
      ? "bg-[#c7c7c7]"
      : status === false
        ? "bg-[#fc4a57]"
        : "bg-[#00aa28]";
  const borderColor =
    status === null ? "#c7c7c7" : status === false ? "#fc4a57" : "#00aa28";
  const textColor =
    status === null
      ? "!text-[#c7c7c7]"
      : status === false
        ? "!text-[#fc4a57]"
        : "!text-[#00aa28]";
  const msgTextColor = status === false ? "!text-[#4283c4]" : "!text-[#00aa28]";

  return (
    <div
      className="box-border"
      style={{ position: "relative", marginTop: -8, marginRight: -8 }}
    >
      <div
        onClick={() => {
          if (status === null) return;
          setOpen(!open);
        }}
        tabindex="0"
        role="button"
        style={{ borderTopRightRadius: "5px" }}
        className={`${bgColor} p-[2px] flex items-center gap-2 cursor-pointer select-none`}
      >
        <span className="bg-[#e8e8e8] text-[12px] flex items-center justify-center px-1 font-bold">
          AI
        </span>
        <span className="flex">
          {!status ? (
            <WarningFilled className="text-white text-[15px]" />
          ) : (
            <CheckCircleFilled className="text-white text-[15px]" />
          )}
          <MoreOutlined className="text-white text-[15px]" />
        </span>
      </div>
      {open && (
        <div
          style={{
            border: `1px solid ${borderColor}`,
          }}
          className="px-2 py-1 absolute right-0 w-[200px] gap-[10px] z-[9] bg-white flex flex-col"
        >
          <div className="flex gap-[10px] flex-grow">
            <span>
              {!status ? (
                <WarningFilled className={`text-[15px] ${textColor}`} />
              ) : (
                <CheckCircleFilled className={`text-[15px] ${textColor}`} />
              )}
            </span>
            <span className={`${msgTextColor}`}>
              {status ? "AI Successful" : message}
            </span>
          </div>
          {status && (
            <div className="flex gap-[10px] justify-center items-center">
              <span>
                <CheckCircleFilled className="text-[15px]" />
              </span>
              <span className="underline font-bold underline-offset-4">
                This is not an error
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AIRemarks;
